<template>
  <div class="view">
    <el-row>
      <el-col :span="6">名称</el-col>
      <el-col :span="18">{{data.name}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">库存</el-col>
      <el-col :span="18">{{data.quantity_available}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">厂商建议零售价</el-col>
      <el-col :span="18">{{data.retail_price}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">销售价</el-col>
      <el-col :span="18">{{data.sale_price}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">外部ID</el-col>
      <el-col :span="18">{{data.external_id}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          :data="data.attribute_list"
          border
          stripe>
          <el-table-column
            prop="name"
            label="规格"
            width="150">
          </el-table-column>
          <el-table-column
            prop="value"
            label="规格值">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'SkuView',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.view
  padding: 0

</style>



// WEBPACK FOOTER //
// src/components/SkuView.vue